var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDirectFugitiveEmissionH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 682.7,
    height: 682.7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 512h512V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 23 3 3 23L2 50l-23-2-3-24Z",
    style: {
      fill: "#ffd772",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(1 0 0 -1 285 612)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1 0 0 -1 0 683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0-26-26 40-40a18 18 0 0 1 26 26z",
    style: {
      fill: "#935d38",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(239 79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 24-24 13 13-24 24z",
    style: {
      fill: "#fbba58",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(202 90)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-13-13 40-40c5-5 6-12 5-18l8 5c7 7 7 19 0 26z",
    style: {
      fill: "#7f4d2a",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(239 79)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h219c35 0 64 36 64 63 0 28-10 38-24 49 8 41-26 71-59 59-1 63-84 93-129 48a61 61 0 0 1-108-27c-32 1-60-20-66-53v-22a56 56 0 0 1-31-54l2-15C-104 24-63-26 0 0",
    style: {
      fill: "#eff6ff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(221 216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c55-23 148 43 101 98-7 13-20 23-36 24a43 43 0 0 1-82-5 43 43 0 0 1-62-38l2-13c-18 0-33-15-33-33S-95 0-77 0Z",
    style: {
      fill: "#eff6ff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(119 355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a107 107 0 1 1-26-26z",
    style: {
      fill: "#375e7d",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(215 103)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a73 73 0 1 1-146 0A73 73 0 0 1 0 0",
    style: {
      fill: "#9fd4fe",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(201 165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-13 0-25-6-33-15 9-14 14-31 14-50 0-46-32-84-72-84h66c7 32 34 53 66 53 4 20 17 36 35 44-6 14-20 24-36 25C34-11 18 0 0 0",
    style: {
      fill: "#d9eeff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(143 505)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c0-53-21-100-55-130H64c35 0 63 36 63 63s-9 37-23 49c7 41-27 70-60 59-1 44-41 71-80 69C-14 81 0 42 0 0",
    style: {
      fill: "#d9eeff",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(377 346)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a73 73 0 0 0-46-116l-14-13c-10-8-21-13-33-16 32-11 67-6 96 14l26 26A107 107 0 0 1-87 59a106 106 0 0 0 47-32c16-5 30-14 40-27",
    style: {
      fill: "#2b4d66",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(187 208)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a73 73 0 0 1-54 71 105 105 0 0 0 14-23c17-34 14-76-8-107l-13-13C-26-66 0-36 0 0",
    style: {
      fill: "#85beef",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(201 165)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-6 4-13 7-21 7a38 38 0 0 1 0-77A31 31 0 0 1 3-59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(249 365)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a38 38 0 0 1-76 0A38 38 0 0 1 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(352 334)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-33c-2 1 2 3 23 33 4 5 6 10 7 14v2a17 17 0 0 1-33 4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(423 277)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h59c35 0 63 36 63 63 0 28-9 38-23 49 8 41-27 71-59 59-1 63-84 93-129 48a61 61 0 0 1-108-27c-39 1-71-30-67-75a56 56 0 0 1-30-54l3-16m131-47h125",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(381 216)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h27m101 98c-7 13-21 23-37 24a43 43 0 0 1-81-5 43 43 0 0 1-62-38l2-13c-18 0-33-15-33-33S-68 0-50 0h15",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(92 355)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h112a23 23 0 0 1 16 39 23 23 0 0 1-32 0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(323 142)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h76",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(304 107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h40a23 23 0 1 0-16-39M-72 0h34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(433 72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 27 27",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(189 77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a73 73 0 0 1 0 146A73 73 0 0 1 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(128 91)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 64-64a18 18 0 0 1 26 26L26 26A106 106 0 1 1 0 0Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(189 77)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 36 36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(208 48)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectFugitiveEmissionH);
export default __webpack_public_path__ + "static/media/DirectFugitiveEmission-h.d55460bc07d96f54064fc7ec86665e57.svg";
export { ForwardRef as ReactComponent };